import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Trash2, Edit, Save, X } from "lucide-react";
import { IconButton ,Box,Typography,  CircularProgress,
  TableBody,
  TableCell,
  TableContainer, Menu, MenuItem,Table,
  TableHead,Paper,Button,
  TableRow,} from "@mui/material";
import * as XLSX from "xlsx";
import { useNavigate } from "react-router-dom";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { GlobalStyles } from "@mui/system";
import Swal from "sweetalert2";

const baseUrl = process.env.REACT_APP_API_BASE_URL;
export default function AddNewFeatureForm() {
      const navigate = useNavigate();
  const [features, setFeatures] = useState([]);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [newFeature, setNewFeature] = useState("");
  const [rowLoading, setRowLoading] = useState({});
  const [editingId, setEditingId] = useState(null);
  const [editingValue, setEditingValue] = useState("");
  const [rowBusy, setRowBusy] = useState({});

  useEffect(() => {
    fetchFeatures();
  }, []);

  const fetchFeatures = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${baseUrl}/api/features/getAll`);
      if (!res.ok) throw new Error("Failed to fetch");
      const data = await res.json();
      setFeatures(data || []);
    } catch (err) {
      console.error(err);
    //   toast.error("Failed to fetch features");
    } finally {
      setLoading(false);
    }
  };

const handleAdd = async (e) => {
  e.preventDefault();
  if (!newFeature.trim()) {
    toast.warn("Please enter a feature name");
    return;
  }

  setSubmitting(true);
  try {
    // ✅ Send as query param with key 'latestFeature'
    const res = await fetch(
      `${baseUrl}/api/features/create?latestFeature=${encodeURIComponent(newFeature.trim())}`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      }
    );

    if (!res.ok) throw new Error("Failed to add feature");
    setNewFeature("");
    fetchFeatures();

    // ✅ Success toast for 1 second
    toast.success("Feature added successfully", { autoClose: 1000 });
  } catch (err) {
    console.error(err);

    // ✅ Error toast for 2 seconds
    toast.error("Failed to add feature", { autoClose: 2000 });
  } finally {
    setSubmitting(false);
  }
};




  const setRowBusyState = (id, state) => {
    setRowBusy((prev) => ({ ...prev, [id]: { ...prev[id], ...state } }));
  };

  const startEdit = (feature) => {
    setEditingId(feature.fId);
    setEditingValue(feature.latestFeature);
  };

  const cancelEdit = () => {
    setEditingId(null);
    setEditingValue("");
  };

const saveEdit = async (id) => {
  if (!editingValue.trim()) {
    toast.warn("Feature name cannot be empty");
    return;
  }

  setRowBusyState(id, { updating: true });

  try {
    // ✅ Send the feature name as a query parameter
    const res = await fetch(
      `${baseUrl}/api/features/update/${id}?latestFeature=${encodeURIComponent(editingValue.trim())}`,
      {
        method: "PATCH",
      }
    );

    if (!res.ok) throw new Error("Failed to update feature");

    // ✅ Refresh list
    fetchFeatures();

    toast.success("Feature updated successfully", { autoClose: 1000 });
    cancelEdit();
  } catch (err) {
    console.error(err);
    toast.error("Failed to update feature", { autoClose: 2000 });
  } finally {
    setRowBusyState(id, { updating: false });
  }
};


const handleDelete = async (id) => {
  const result = await Swal.fire({
    title: "Are you sure?",
    text: "This action will permanently delete the feature.",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Yes, delete it!",
    cancelButtonText: "Cancel",
  });

  if (!result.isConfirmed) return;

  setRowBusyState(id, { deleting: true });

  try {
    const res = await fetch(`${baseUrl}/api/features/delete/${id}`, {
      method: "DELETE",
    });

    if (!res.ok) throw new Error("Failed to delete feature");

    fetchFeatures();

    // ✅ Success toast (1 second)
    toast.success("Feature deleted successfully", { autoClose: 1000 });
  } catch (err) {
    console.error(err);

    // ❌ Error toast (2 seconds)
    toast.error("Failed to delete feature", { autoClose: 2000 });
  } finally {
    setRowBusyState(id, { deleting: false });
  }
};

  return (
    <div style={{  margin: "4% 0% 0% 0%", padding: "24px" }}>
      <ToastContainer position="top-right" />
      <div
        style={{
          backgroundColor: "#fff",
          border: "1px solid #e5e7eb",
          borderRadius: "16px",
          boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
          padding: "24px",
        }}
      >
        {/* <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
          <h2 style={{ fontSize: "18px", fontWeight: "600", margin: 0 }}>Add New Feature</h2>
        </div> */}
<Box display="flex" alignItems="center" sx={{ marginBottom: 2 }}>
            <IconButton onClick={() => navigate(-1)} sx={{ color: "#2e2a54" }}>
              <KeyboardBackspaceIcon fontSize="medium" />
            </IconButton>
            <Typography variant="h4" component="h3" sx={{ fontWeight: "bold" }}>
              Add New Feature
            </Typography>
          </Box>





<div
  style={{
    display: "flex",
    alignItems: "center",
    gap: "10px",
    flexWrap: "wrap",
    justifyContent: "flex-start",
    marginBottom: "16px",
  }}
>
  <div style={{ display: "flex", flexDirection: "column" }}>
    <label
      htmlFor="featureName"
      style={{
        fontSize: "14px",
        fontWeight: "bold",
        color: "#334155",
        marginBottom: "4px",
      }}
    >
      Feature Name:
    </label>
    <input
      id="featureName"
      style={{
        width: "240px",
        border: "1px solid #cbd5e1",
        borderRadius: "6px",
        padding: "8px 10px",
        fontSize: "14px",
        outline: "none",
        transition: "all 0.2s ease",
        boxShadow: "inset 0 1px 2px rgba(0,0,0,0.05)",
      }}
      placeholder="Enter feature name"
      value={newFeature}
      onChange={(e) => setNewFeature(e.target.value)}
      onKeyDown={(e) => {
        if (e.key === "Enter") handleAdd(e);
      }}
      onFocus={(e) => (e.target.style.borderColor = "#2563eb")}
      onBlur={(e) => (e.target.style.borderColor = "#cbd5e1")}
    />
  </div>

  <button
    onClick={handleAdd}
    disabled={submitting}
    style={{
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "8px",
      backgroundColor: submitting ? "#475569" : "#3C3972",
      color: "#fff",


      padding: "8px 16px",
      borderRadius: "6px",
      border: "none",
      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
      cursor: "pointer",
      transition: "all 0.2s ease",
      opacity: submitting ? 0.9 : 1,
      minWidth: "100px",
      height: "35px",
      position: "relative",
      marginTop: "25px", // aligns nicely with the label
    }}
    onMouseEnter={(e) => (e.target.style.backgroundColor = "#334155")}
    onMouseLeave={(e) => (e.target.style.backgroundColor = "#1e293b")}
  >
    {submitting ? (
      <div
        style={{
          border: "3px solid rgba(255,255,255,0.3)",
          borderTop: "3px solid white",
          borderRadius: "50%",
          width: "16px",
          height: "16px",
          animation: "spin 1s linear infinite",
        }}
      ></div>
    ) : (
      <span>Submit</span>
    )}
  </button>
</div>

<style>
  {`@keyframes spin {
    to { transform: rotate(360deg); }
  }`}
</style>

<GlobalStyles
              styles={{
                ".custom-sidebar-scrollbar": {
                  scrollbarWidth: "thin", // For Firefox
                  scrollbarColor: "grey #e0e0e0",
                },
                ".custom-sidebar-scrollbar::-webkit-scrollbar": {
                  width: "6px", // For WebKit-based browsers
                },
                ".custom-sidebar-scrollbar::-webkit-scrollbar-track": {
                  background: "#f1f1f1", // Track color
                },
                ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb": {
                  backgroundColor: "grey", // Thumb color
                  borderRadius: "10px",
                },
                ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover": {
                  backgroundColor: "#555",
                },
              }}
            />


          <div style={{boxShadow: "0 2px 4px rgba(246, 241, 241, 0.93)", }}>
             <h3 style={{ fontWeight: 'bold', fontSize: "16px", paddingBottom: '5px', }}>New Features</h3>
          <TableContainer
      component={Paper}
      sx={{ maxHeight: 500, overflowY: "auto" }}
      className="custom-sidebar-scrollbar"
    >
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            {["Sl No", "Feature Name", "Created", "Actions"].map((header) => (
              <TableCell
                key={header}
                sx={{
                  fontWeight: "bold",
                  padding: "4px",
                  fontSize: "14px",
                  textAlign: "center",
                  borderRight: "1px solid #ddd",
                  backgroundColor: "#fff9c4",
                }}
              >
                {header}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {loading ? (
            <TableRow>
              <TableCell colSpan={4} align="center" sx={{ py: 3 }}>
                <Box display="flex" flexDirection="column" alignItems="center">
                  <CircularProgress />
                  <Typography sx={{ mt: 1 }}>Loading features...</Typography>
                </Box>
              </TableCell>
            </TableRow>
          ) : features.length === 0 ? (
            <TableRow>
              <TableCell colSpan={4} align="center" sx={{ py: 3 }}>
                No features yet.
              </TableCell>
            </TableRow>
          ) : (
            features.map((feature, index) => {
              const isEditing = editingId === feature.fId;
              const busy = rowBusy[feature.fId] || {};

              return (
                <TableRow
                  key={feature.fId}
                  sx={{
                    backgroundColor: "white",
                    "&:hover": { backgroundColor: "#f5f5f5" },
                    borderTop: "1px solid #e2e8f0",
                  }}
                >
                  <TableCell
                    sx={{
                      textAlign: "center",
                      fontSize: "14px",
                      color: "#64748b",
                      padding: "4px",
                      borderRight: "1px solid #ddd",
                    }}
                  >
                    {index + 1}
                  </TableCell>

                  {/* Feature Name */}
                  <TableCell
                    sx={{
                      textAlign: "center",
                      fontSize: "14px",
                      fontWeight: 500,
                      padding: "4px",
                      borderRight: "1px solid #ddd",
                    }}
                  >
                    {isEditing ? (
                      <input
                        value={editingValue}
                        onChange={(e) => setEditingValue(e.target.value)}
                        style={{
                          width: "240px",
                          border: "1px solid #d1d5db",
                          borderRadius: "6px",
                          padding: "6px 8px",
                        }}
                      />
                    ) : (
                      feature.latestFeature
                    )}
                  </TableCell>

                  {/* Created Date */}
                  <TableCell
                    sx={{
                      textAlign: "center",
                      fontSize: "14px",
                      color: "#64748b",
                      padding: "4px",
                      borderRight: "1px solid #ddd",
                    }}
                  >
                    {feature.date}
                  </TableCell>

                  {/* Actions */}
                  <TableCell sx={{
                      textAlign: "center",
                      padding: "4px",
                    }}>
                      <>
                       <Button
                            variant="outlined"
                            size="small"
                            color="error"
                            onClick={() => handleDelete(feature.fId)}
                            disabled={busy.deleting}
                            sx={{
                              textTransform: "none",
                              fontSize: "13px",
                              borderRadius: "6px",
                            }}
                          >
                            {busy.deleting ? (
                              <CircularProgress size={14} color="inherit" />
                            ) : (
                              "Delete"
                            )}
                          </Button>
                        </>
                    {/* <Box display="flex" gap={1} justifyContent="center">
                      {isEditing ? (
                        <>
                          <Button
                            variant="contained"
                            color="success"
                            size="small"
                            onClick={() => saveEdit(feature.fId)}
                            disabled={busy.updating}
                            sx={{
                              textTransform: "none",
                              fontSize: "13px",
                              borderRadius: "6px",
                               backgroundColor: "#3C3972",
                                fontWeight: 'bold',
                                color: "#fff",
                                "&:hover": { backgroundColor: "#3C3972" },
                            }}
                             
                          >
                            {busy.updating ? (
                              <CircularProgress size={14} color="inherit" />
                            ) : (
                              "Save"
                            )}
                          </Button>

                          <Button
                            variant="outlined"
                            color="inherit"
                            size="small"
                            onClick={cancelEdit}
                            startIcon={<X size={14} />}
                            sx={{
                              textTransform: "none",
                              fontSize: "13px",
                              borderRadius: "6px",
                            }}
                          >
                            Cancel
                          </Button>
                        </>
                      ) : (
                        <>
                          <Button
                            variant="outlined"
                            size="small"
                            onClick={() => startEdit(feature)}
                            startIcon={<Edit size={14} />}
                            sx={{
                              textTransform: "none",
                              fontSize: "13px",
                              borderRadius: "6px",
                            }}
                          >
                            Edit
                          </Button>

                          <Button
                            variant="outlined"
                            size="small"
                            color="error"
                            onClick={() => handleDelete(feature.fId)}
                            disabled={busy.deleting}
                            sx={{
                              textTransform: "none",
                              fontSize: "13px",
                              borderRadius: "6px",
                            }}
                          >
                            {busy.deleting ? (
                              <CircularProgress size={14} color="inherit" />
                            ) : (
                              "Delete"
                            )}
                          </Button>
                        </>
                      )}
                    </Box> */}
                  </TableCell>
                </TableRow>
              );
            })
          )}
        </TableBody>
      </Table>
    </TableContainer>
          </div>

      </div>
    </div>
  );
}
